// Saklar sementara untuk fitur absensi yang belum dipakai. Sengaja ditaruh di
// satu berkas, bukan dengan mengomentari JSX di masing-masing halaman, supaya
// menyalakannya kembali cukup mengubah satu baris di sini dan tidak ada
// potongan kode mati yang tercecer di beberapa file.
//
// Sisi backend TIDAK ikut dimatikan: endpoint /rfid-mapping, /attendance/zoom/import,
// dan /attendance/:classCode/:batch/recompute tetap hidup, begitu juga cron
// Fingerspot 23:50 yang terus mengumpulkan tap. Jadi datanya tetap terkumpul
// selama fitur ini disembunyikan, dan tinggal ditampilkan lagi nanti.
export const SHOW_RFID_MAPPING = false;
export const SHOW_ZOOM_IMPORT = false;
export const SHOW_RECOMPUTE = false;
